import cryptoJs from "crypto-js";

let keyOne = 'bnPvN0oy2GJ5k+wVlEXReQ=='
export default {
  // 加密函數
  encrypt(word) {
    let key = cryptoJs.enc.Utf8.parse(keyOne)
    let encryptedStr = ''
    // if (typeof word === 'string') {
    encryptedStr = cryptoJs.AES.encrypt(word, key, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    })
    // } else if (typeof word === 'object') {
    //   console.log("加密文件类型：", "object")
    //   let data = JSON.stringify(word)
    //   console.log(data)
    //   // encryptedStr = cryptoJs.AES.encrypt(data, key, {
    //   //   mode: cryptoJs.mode.CBC,
    //   //   padding: cryptoJs.pad.Pkcs7
    //   // })
    //   this.encrypt(data)
    // }
    // setTimeout(, 0`)
    return encryptedStr.toString();
  },
  // 解密函數
  decrypt(word) {
    let key = cryptoJs.enc.Utf8.parse(keyOne)
    //先将Base64还原一下，因为加密的时候做了一些字符的替换
    const restoreBase64 = word.replace(/\-g/, '+').replace(/_/, '/');
    //返回的是解密后的对象
    let decrypt = cryptoJs.AES.decrypt(restoreBase64, key, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    });
    //将解密对象转换成UTF8的字符串
    let decryptedStr = decrypt.toString(cryptoJs.enc.Utf8);
    //返回解密结果
    return decryptedStr.toString();

  }
}


// 第一步引入：import AES from "../../js/AES";
// 每个页面上都需要引入

// 第二部 对你所需要的 对象进行加密： AES.encrypt(JSON.stringify(bbb))
// 可以生成 密文自己先查看格式有无错误
//  console.log("加密后生成的密文：", AES.encrypt(JSON.stringify(bbb)));

// 第三部 从后端传回的数据进行解密： AES.decrypt(aaa)
// 可以自己先查看格式有无错误
// console.log("解密：" + AES.decrypt(aaa));

// 对解密后的东西进行json格式处理
// JSON.parse(AES.decrypt(aaa))



// WEBPACK FOOTER //
// ./src/js/AES.js